export const visit = (vm, at) => {
vm(require("commerce-contract-lib/lang/en.lyaml"));
at({ "en": { "cardBizOpsRelatedContacts": { "profileSidebarModule": { "bizOpsRelatedContactsModule": { "header": "Related Contacts" } } } } });
};